import React, { useState } from "react";
import "./QuizTT.css";
import ModalBox from "../../components/ModalBox/ModalBox";
import questions from "./questions";
import ActivityHeader from "../../components/ActivityHeader/ActivityHeader";
import { startModal, resultModal, finalModal } from "./Modals";
import { trackGameStart } from "../../utils/trackEvents";

export default function QuizTT() {
  const [showStart, setShowStart] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showScoreModal, setShowScoreModal] = useState(false);
  const [score, setScore] = useState(0);
  const [lastCorrect, setLastCorrect] = useState(false);

  const { question, options, answer, explanation } = questions[currentIndex];

  const handleOptionClick = (opt) => {
    const correct = opt === answer;
    setLastCorrect(correct);
    if (correct) setScore((s) => s + 1);
    setIsModalOpen(true);
  };

  const handleNext = () => {
    setIsModalOpen(false);
    if (currentIndex + 1 < questions.length) {
      setCurrentIndex((i) => i + 1);
    } else {
      setShowScoreModal(true);
    }
  };

  const handleRestart = () => {
    setShowScoreModal(false);
    setCurrentIndex(0);
    setScore(0);
    setShowStart(true);
  };

  const handleStartClose = () => {
    setShowStart(false);
    trackGameStart("QuizTT", 1);
  };

  return (
    <div className="quiz-tt-main">
      <ActivityHeader>
        {!showStart && (
          <>
            <div className="quiz-tt-header-number">
              Question: {currentIndex + 1}/{questions.length}
            </div>
            <div className="quiz-tt-header-score">Score: {score}</div>
          </>
        )}
      </ActivityHeader>
      <div className="quiz-tt-question">
        {!showStart && (
          <>
            <div className="quiz-tt-question-content">{question}</div>
            <div className="quiz-tt-question-options">
              {options.map((opt, i) => (
                <div
                  key={i}
                  className={`quiz-tt-question-options-${String.fromCharCode(
                    65 + i
                  )}`}
                  onClick={() => handleOptionClick(opt)}
                >
                  {opt}
                </div>
              ))}
            </div>
          </>
        )}
      </div>

      {/* Start Modal */}
      <ModalBox
        isOpen={showStart}
        {...startModal()}
        onClose={handleStartClose}
      />

      {/* Result Modal */}
      {!showScoreModal && (
        <ModalBox
          isOpen={isModalOpen}
          {...resultModal(
            lastCorrect,
            explanation,
            currentIndex + 1 === questions.length
          )}
          onClose={handleNext}
        />
      )}

      {/* Final Score Modal */}
      {showScoreModal && (
        <ModalBox
          isOpen={showScoreModal}
          {...finalModal(score, questions.length, handleRestart)}
        />
      )}
    </div>
  );
}
